module.exports = __webpack_public_path__ + "img/down-anhui2.faebfe4d.jpg";